<div class="side-menu" [ngClass]="isMobileScreen && 'mobile-mode'">
  <app-side-menu
    #sideMenuRef
    [(opened)]="sideMenuService.opened"
    [menuItems]="menuItems"
    [showLogo]="canShowLogo"
    [showToggleButton]="false"
    [textEnabled]="menuTextEnabled"
    [openTriggerMode]="isMobileScreen ? 'none' : 'mouseover'"
    closeTriggerMode="none"
    [closeOutsideClickEnabled]="isMobileScreen"
    (onOpening)="onSidemenuOpening()"
    (onClosed)="onSidemenuClosed()"
    (onLogoClick)="onSidemenuLogoClick($event)"
  >
    <div
      side-menu-footer
      class="btn-siia-container"
      *ngIf="!appConfig.siiaMode"
    >
      <a [href]="appConfig.siiaLink" target="_blank">
        <app-button
          class="btn-siia"
          buttonType="normal"
          styleType="contained"
          shapeType="square"
          text="SIIA"
          width="100%"
          [disabled]="!appConfig.siiaLink"
        ></app-button>
      </a>
    </div>
  </app-side-menu>

  <ng-template #menuItemWithSlideToggleTpl let-item="item">
    <div class="item-content">
      <app-slide-toggle
        class="slide-toggle"
        [value]="item.selected"
        [readOnly]="true"
      ></app-slide-toggle>

      <div class="text" *ngIf="!!(item.text && menuTextEnabled)">
        {{ item.text }}
      </div>
    </div>
  </ng-template>
</div>

<app-overlay-mask
  class="overlay-mask"
  *ngIf="!!isMobileScreen"
  [visible]="!!((sideMenuRef.opening || sideMenuRef.opened) && !sideMenuRef.closing && !sideMenuRef.closed)"
></app-overlay-mask>

<div class="map-container" [ngClass]="isMobileScreen && 'mobile-mode'">
  <app-main-map
    [showLogo]="canShowLogo && !isMobileScreen"
    (onMapClick)="onMapClick($event)"
  ></app-main-map>

  <app-cookies-disclaimer
    class="cookies-disclaimer"
    [ngClass]="isMobileScreen && 'mobile-mode'"
    *ngIf="!!(appConfig.externalMode && appTrackingService.isRequestPendingGoogle)"
  ></app-cookies-disclaimer>
</div>
